import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import * as moment from 'moment';

@Component({
    selector: 'sharyx-call-history-tab',
    templateUrl: './sharyxCallHistory.component.html',
})
export class SharyxCallHistoryComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('outcomeTemplate') outcomeTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    suppressPaging = false;
    scrollTimeout: any;

    filterData: any = {
        search_data: '',
        from_date: new Date(),
        to_date: new Date(),
    };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cal.received_at',
        orderDir: 'desc'
    };

    columns = [];
    reportData: any[] = [];
    summaryStats: any = { total: 0, connected: 0, not_connected: 0, with_recording: 0 };

    selectedRow: any = null;
    callLog: any[] = [];
    loadingCallLog = false;
    bsModalRef: BsModalRef;

    constructor(
        private http: Http,
        private toasterService: ToasterService,
        private modalService: BsModalService
    ) {}

    ngOnInit() {
        this.columns = [
            { name: 'SNo',          prop: 'sno',             width: 80,  minWidth: 80,  maxWidth: 80,  sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Client ID',    prop: 'client_no',       width: 130, minWidth: 130, maxWidth: 130 },
            { name: 'Name',         prop: 'client_name',     width: 160, minWidth: 160, maxWidth: 160, sortable: false },
            { name: 'Mobile',       prop: 'to_number',       width: 145, minWidth: 145, maxWidth: 145, sortable: false },
            { name: 'Lead Added',   prop: 'lead_added_date', width: 130, minWidth: 130, maxWidth: 130, sortable: false },
            { name: 'Campaign',     prop: 'campaign_name',   width: 160, minWidth: 160, maxWidth: 160, sortable: false },
            { name: 'Status',       prop: 'outcome',         width: 155, minWidth: 155, maxWidth: 155, sortable: false, cellTemplate: this.outcomeTemplate },
            { name: 'Call Date',    prop: 'call_time',       width: 145, minWidth: 145, maxWidth: 145, sortable: false },
            { name: 'Duration (s)',    prop: 'call_duration',   width: 130, minWidth: 130, maxWidth: 130, sortable: false },
            { name: 'Call End Reason', prop: 'call_end_reason', width: 160, minWidth: 160, maxWidth: 160, sortable: false },
            { name: 'Action',          prop: 'id',              width: 215, minWidth: 215, maxWidth: 215, sortable: false, cellTemplate: this.actionTemplate },
        ];
        this.getList();
        this.loadSummaryStats();
    }

    ngOnChanges() {
        if (this.active) {
            this.getList();
            this.loadSummaryStats();
        }
    }

    loadSummaryStats() {
        const p = this.buildParams(0, 0);
        const options = new RequestOptions({ headers: this.headers, search: p });
        this.http.get('api/aiCallWebhook/getCallHistorySummary', options)
            .toPromise()
            .then((res: any) => {
                const body = res.json();
                if (body.success && body.data) {
                    this.summaryStats = {
                        total: body.data.total || 0,
                        connected: body.data.connected || 0,
                        not_connected: body.data.not_connected || 0,
                        with_recording: body.data.with_recording || 0
                    };
                }
            })
            .catch(() => {});
    }

    pageCallback(pageInfo: any) {
        this.page.offset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page - 1);
        if (!this.suppressPaging) { this.getList(); }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    sortCallback(sortInfo: any) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    applyFilter() {
        this.page.offset = 0;
        this.filterPanel.close();
        this.getList();
        this.loadSummaryStats();
    }

    clearFilter() {
        this.filterData = { search_data: '', from_date: new Date(), to_date: new Date() };
        this.applyFilter();
    }

    buildParams(start: number, limit: number): URLSearchParams {
        const params = new URLSearchParams();
        params.set('start', `${start}`);
        params.set('limit', `${limit}`);
        params.set('orderColumn', this.page.orderBy);
        params.set('orderDir', this.page.orderDir);
        params.set('search_data', this.filterData.search_data || '');
        if (this.filterData.from_date) {
            params.set('from_date', moment(this.filterData.from_date).format('YYYY-MM-DD'));
        }
        if (this.filterData.to_date) {
            params.set('to_date', moment(this.filterData.to_date).format('YYYY-MM-DD'));
        }
        return params;
    }

    getList() {
        const options = new RequestOptions({ headers: this.headers, search: this.buildParams(this.page.offset * this.page.limit, this.page.limit) });
        this.isLoadMask = this.http.get('api/aiCallWebhook/getCallHistory', options)
            .toPromise()
            .then((res: any) => {
                const body = res.json();
                this.loadingIndicator = false;
                this.page.count = body.totCnt || 0;
                this.reportData  = body.data  || [];
            })
            .catch(() => {
                this.loadingIndicator = false;
                this.toasterService.pop('error', 'Error', 'Failed to load call history');
            });
    }

    viewCallHistory(row: any, tpl: TemplateRef<any>) {
        this.selectedRow   = row;
        this.callLog       = [];
        this.loadingCallLog = true;
        this.bsModalRef = this.modalService.show(tpl, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-lg maxWidthPer-80 clienthistorywidth'
        });

        const p = new URLSearchParams();
        p.set('client_id', row.client_id);
        const options = new RequestOptions({ headers: this.headers, search: p });

        this.http.get('api/aiCallWebhook/getCallLog', options)
            .toPromise()
            .then((res: any) => {
                this.loadingCallLog = false;
                this.callLog = res.json().data || [];
            })
            .catch(() => {
                this.loadingCallLog = false;
                this.toasterService.pop('error', 'Error', 'Failed to load call log');
            });
    }

    closeModal() {
        if (this.bsModalRef) { this.bsModalRef.hide(); }
    }

    downloadExcel() {
        const p = this.buildParams(0, 9999);
        p.set('export', 'excel');
        window.open(`api/aiCallWebhook/exportCallHistory?${p.toString()}`, '_blank');
    }

    downloadPdf() {
        const p = this.buildParams(0, 9999);
        p.set('export', 'pdf');
        window.open(`api/aiCallWebhook/exportCallHistory?${p.toString()}`, '_blank');
    }

    downloadClientPdf(row: any) {
        const p = new URLSearchParams();
        p.set('client_id', row.client_id);
        p.set('export', 'pdf');
        window.open(`api/aiCallWebhook/exportClientCallHistory?${p.toString()}`, '_blank');
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/sharyxCallHistory/sharyxCallHistory.component.ts